"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const Audiences_1 = require("../../constants/Audiences");
const AuthorizationScopes_1 = __importDefault(require("../../enums/AuthorizationScopes"));
const middleware_1 = require("../helper/middleware");
class VaultMiddleware {
    previousPortalToken = null;
    post(context) {
        return (0, middleware_1.postWithToken)(context);
    }
    pre(context) {
        return (0, middleware_1.preWithToken)(context, Audiences_1.Audiences.VAULT, [
            AuthorizationScopes_1.default.DELEGATE,
            AuthorizationScopes_1.default.PROFILE_READ,
            AuthorizationScopes_1.default.PROFILE_UPDATE,
        ]);
    }
    setPreviousPortalToken(token) {
        this.previousPortalToken = token;
    }
    getPreviousPortalToken() {
        return this.previousPortalToken;
    }
}
__decorate([
    bind_decorator_1.default
], VaultMiddleware.prototype, "setPreviousPortalToken", null);
__decorate([
    bind_decorator_1.default
], VaultMiddleware.prototype, "getPreviousPortalToken", null);
exports.default = new VaultMiddleware();
